
jQuery(document).ready(function () {
	var $loadmore = jQuery('#loadMore'),
		hostString = window.location.protocol + '//' + window.location.host;

	// only show "load more" button if we have not reached final page
	 if($loadmore.attr('data-currentpage') < $loadmore.attr('data-maxpage') ){
		 $loadmore.css('display', 'block');
	 }

	// Set up "Load More" button
	$loadmore.click(function(e){
		e.preventDefault();
		var nextpage = Number($loadmore.attr('data-currentpage')) + 1;
		var maxpage = Number($loadmore.attr('data-maxpage'));
		var ajaxString = hostString + '/more-press?page=' + nextpage;
		// delaying firing of equalHeight until a moment after the html is appended
		// eliminates race condition with ff and ie

		jQuery.post( ajaxString, function( data ) {
			jQuery("#articles").append( data );
		});

		$loadmore.attr('data-currentpage', nextpage);
		if($loadmore.attr('data-currentpage') >= maxpage){
			$loadmore.hide();
		}
	});
});
